import { Divider, Text } from '@zillow/constellation-10';

import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const DuplicateListingDetailsContainer = ({ children }: Props) => (
  <div data-testid="DuplicateListingDetails">
    <Text asChild textStyle="heading-sm" css={{ marginBottom: { base: '200', lg: '400' } }}>
      <p>Additional listing sources</p>
    </Text>
    {children}
    <Divider css={{ opacity: 'disabled', flexBasis: 'initial', marginBlock: '600' }} />
  </div>
);

export default DuplicateListingDetailsContainer;
